import {
  Card,
  Container,
  Icon,
  List,
  Section,
  Stack,
  useDialogProvider,
} from "@storoey/sui";
import { createFileRoute, useNavigate } from "@tanstack/solid-router";
import { createDexieArrayQuery } from "solid-dexie";
import { For, onMount } from "solid-js";
import { database } from "../../backend/database";
import { useNavbar } from "../../contexts/RootContext";
import { CreateTemplateDialog } from "../../dialogs/Template/CreateTemplate.dialog";

export const Route = createFileRoute("/templates/")({
  staticData: {
    navTitle: "Maler",
    backLabel: "Hjem",
    backTo: "/",
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { setTitle } = useNavbar();
  const navigate = useNavigate();

  onMount(() => {
    setTitle("Maler");
  });

  const templates = createDexieArrayQuery(() =>
    database.templates.reverse().toArray()
  );

  const dialog = useDialogProvider();

  return (
    <>
      <Section padding="md">
        <Container>
          <Stack>
            <Card elevation={200}>
              <Card.Content>
                <Card.Title>Maler</Card.Title>
                <Card.Text>Liste over alle maler</Card.Text>
              </Card.Content>
              <Card.Actions>
                <List>
                  <List.Item leading={<Icon>add</Icon>} onClick={dialog.open}>
                    Legg til mal
                  </List.Item>
                  <For each={templates}>
                    {(template) => (
                      <List.Item
                        leading={<Icon>star</Icon>}
                        trailingText={Intl.DateTimeFormat("no-NB", {
                          dateStyle: "short",
                        }).format(template.createdAt)}
                        trailingIcon="chevron_right"
                        onClick={() =>
                          navigate({
                            to: `/templates/${template.id}`,
                          })
                        }
                      >
                        {template.title}
                      </List.Item>
                    )}
                  </For>
                </List>
              </Card.Actions>
            </Card>
          </Stack>
        </Container>
      </Section>

      <CreateTemplateDialog
        open={dialog.open}
        close={dialog.close}
        isOpen={dialog.isOpen}
      />
    </>
  );
}
